var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 189,
    viewBox: "0 0 190 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 94.5,
    r: 94.5,
    fill: "url(#paint0_linear_459_8500)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.414 57.1375H71.5807C57.8307 57.1375 48.6641 66.3041 48.6641 80.0541V107.554C48.6641 121.304 57.8307 130.471 71.5807 130.471V140.233C71.5807 143.9 75.6599 146.1 78.6849 144.037L99.0807 130.471H117.414C131.164 130.471 140.331 121.304 140.331 107.554V80.0541C140.331 66.3041 131.164 57.1375 117.414 57.1375ZM94.4974 112.917C92.5724 112.917 91.0599 111.358 91.0599 109.479C91.0599 107.6 92.5724 106.042 94.4974 106.042C96.4224 106.042 97.9349 107.6 97.9349 109.479C97.9349 111.358 96.4224 112.917 94.4974 112.917ZM100.272 93.8958C98.4849 95.0875 97.9349 95.8666 97.9349 97.15V98.1124C97.9349 99.9916 96.3766 101.55 94.4974 101.55C92.6182 101.55 91.0599 99.9916 91.0599 98.1124V97.15C91.0599 91.8333 94.9557 89.2208 96.4224 88.2125C98.1182 87.0666 98.6682 86.2874 98.6682 85.0958C98.6682 82.8041 96.7891 80.9249 94.4974 80.9249C92.2057 80.9249 90.3266 82.8041 90.3266 85.0958C90.3266 86.9749 88.7682 88.5333 86.8891 88.5333C85.0099 88.5333 83.4516 86.9749 83.4516 85.0958C83.4516 78.9999 88.4016 74.05 94.4974 74.05C100.593 74.05 105.543 78.9999 105.543 85.0958C105.543 90.3208 101.693 92.9333 100.272 93.8958Z",
    fill: "#206648"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_459_8500",
    x1: 34.2148,
    y1: 44.543,
    x2: 189.5,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BD47",
    stopOpacity: 0.45
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.1f3550cf3d3a1c4a6c42fb96865b95fc.svg";
export { ForwardRef as ReactComponent };